import { Overbooking } from "PFApp/booking/types";
import { Booking } from "PFTypes";

type FilterOverbookingsData = {
  overbookings: Overbooking[];
  bookings: Pick<Booking, "start_date" | "end_date">[];
};

export const filterOverbookingsMatchingBookingsByDate = ({
  overbookings,
  bookings
}: FilterOverbookingsData): Overbooking[] => {
  const parsedBookings = bookings.map(({ start_date: startDate, end_date: endDate }) => ({
    start: new Date(startDate).getTime(),
    end: new Date(endDate).getTime()
  }));
  return overbookings.filter(({ date: overbookingDate }) => {
    const date = new Date(overbookingDate).getTime();
    return parsedBookings.some(({ start, end }) => date >= start && date <= end);
  });
};
